import {ChangeDetectionStrategy, Component, EventEmitter, Input, Output} from '@angular/core';
import {TitleCasePipe} from '@angular/common';
import {MatIconModule} from '@angular/material/icon';
import {ProjectActionOption} from 'src/app/core/model/project';

@Component({
  selector: 'project-selector-menu-action-button',
  standalone: true,
  imports: [MatIconModule, TitleCasePipe],
  template: `
    <button class="oph-select-menu-item" (click)="buttonClick.emit()">
      <div class="menu-item-container">
        <mat-icon [svgIcon]="option.icon"></mat-icon>
        <span class="action-label">{{ option.action | titlecase }}</span>
      </div>
    </button>
  `,
  styles: [
    `
      :host {
        display: block;
      }

      .menu-item-container {
        display: flex;
        align-items: center;
        gap: 8px;
        padding: 8px 16px;
        cursor: pointer;
      }

      .action-label {
        font-family: 'Asap', sans-serif;
        font-size: 14px;
        color: #4a443d;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProjectSelectorMenuActionButtonComponent {
  @Input() option: ProjectActionOption;

  @Output() buttonClick = new EventEmitter<void>();
}
